import { useCallback, useState } from 'react';
import { ConfirmModal } from './ConfirmModal';

type NotifyVariant = 'danger' | 'warning' | 'info' | 'success';

interface NotifyState {
  title: string;
  message: string;
  variant: NotifyVariant;
  okText?: string;
  onClose?: () => void;
}

export function useNotify() {
  const [state, setState] = useState<NotifyState | null>(null);

  const notify = useCallback(
    (
      title: string,
      message: string,
      variant: NotifyVariant = 'info',
      options?: { okText?: string; onClose?: () => void },
    ) => {
      setState({ title, message, variant, okText: options?.okText, onClose: options?.onClose });
    },
    [],
  );

  const dismiss = useCallback(() => {
    if (state?.onClose) state.onClose();
    setState(null);
  }, [state]);

  const NotifyModal = (
    <ConfirmModal
      isOpen={state !== null}
      title={state?.title ?? ''}
      message={state?.message ?? ''}
      confirmText={state?.okText ?? 'OK'}
      variant={state?.variant ?? 'info'}
      hideCancel
      onConfirm={dismiss}
      onCancel={dismiss}
    />
  );

  return { notify, NotifyModal };
}
